import { zSidLabel } from "src/types";
import z from "zod";

import { zSysDataHistory } from "../sysData/ZSysData";

export const zValueCatalogData = z.object({
  name: z.string(),
  description: z.string().nullish(),
  schema: zSidLabel,
});
export type ZValueCatalogData = z.infer<typeof zValueCatalogData>;

export const zValueCatalog = z.object({
  id: z.string(),
  displayId: z.number(),
  ...zValueCatalogData.shape,
  ...zSysDataHistory.shape,
});

export type ZValueCatalog = z.infer<typeof zValueCatalog>;

export type ValueCatalogSave = Omit<ZValueCatalogData, "schema"> & {
  schemaId: string;
};

export const makeValueCatalogData = (src: ZValueCatalog): ZValueCatalogData => {
  const { name, description, schema } = src;
  return { name, description, schema };
};

export const makeValueCatalogSave = (
  data: ZValueCatalogData,
): ValueCatalogSave => ({
  name: data.name,
  description: data.description,
  schemaId: data.schema.id,
});
